/**
 * Renders the non-success states of a data-driven widget.
 * status: 'loading' | 'success' | 'empty' | 'error'
 * Children are rendered only for 'success'.
 */
export default function MetricState({ status, onRetry, emptyText = 'No data for this period yet.', minHeight = 96, error, children }) {
  if (status === 'loading') {
    return (
      <div className="placeholder-glow" style={{ minHeight }} role="status" aria-live="polite" aria-busy="true" data-state="loading">
        <span className="visually-hidden">Loading</span>
        <span className="placeholder col-5 mb-2 d-block rounded" style={{ height: 28 }} />
        <span className="placeholder col-8 d-block rounded" style={{ height: 14 }} />
      </div>
    );
  }
  if (status === 'empty') {
    return (
      <div className="cb-state text-muted" style={{ minHeight }} data-state="empty">
        <i className="bi bi-inbox fs-4" aria-hidden="true" />
        <span className="small">{emptyText}</span>
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div className="cb-state text-danger" style={{ minHeight }} role="alert" data-state="error">
        <i className="bi bi-exclamation-triangle fs-4" aria-hidden="true" />
        <span className="small">{error?.message || 'Unable to load this data.'}</span>
        {onRetry && (
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={onRetry}>
            <i className="bi bi-arrow-clockwise me-1" aria-hidden="true" />Retry
          </button>
        )}
      </div>
    );
  }
  return <div data-state="success">{children}</div>;
}
